import React, { useState, useEffect, useMemo } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "../../style.css";
import "./header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import swal from "sweetalert";
import { logoutAdmin } from "../../utils/logoutadmin";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  captureSwitchCareSiteId,
  currentCareSiteId,
  currentCareSiteIdHandler,
  selectCareSite,
  switchCareSiteApi,
  updateCurrentCareSite,
} from "../../redux-toolkit/reducer/switchSites";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { securityQuestions } from "../../constants/constants";
import {
  authProcess,
  authenticateOwnerSignup,
  getOwnerId,
  loginOwnerId,
  getOwnerIdAfterLogin,
  securitysuccessfullMsg,
  handleEmailVerifyFromLogin,
} from "../../redux-toolkit/reducer/accountCreationApiReducer";
import { AiFillPlusCircle } from "react-icons/ai";
import { httpAdmin } from "../../Apis/commonApis";
import CircularProgress from "@mui/material/CircularProgress";
import { RefreshPage } from "../../utils/utilsHandlerFunctions";
import {
  compressImage,
  labelValInitialState,
} from "../../utils/CommonFunctions";
import { useForm } from "react-hook-form";
import AwsLocation from "../../utils/AwsLocation";
import { ShowSwal } from "../../utils/alertSwal";
import { io } from "socket.io-client";
import { setSocketCount } from "../../redux-toolkit/reducer/caresiteDataReducer";
import { getSettingList } from "../../redux-toolkit/reducer/adminSettings";
import { debounce } from "lodash";
import {
  fetchUserIpData,
  getTaxesAndCurrency,
} from "../../redux-toolkit/reducer/websitePlan";
import countryList from "../Signup/countries.json";
import { Checkbox } from "@mui/material";
import { SUPPORTED_COUNTRY_CODES } from "../Signup/StepTwoCareSiteDetails";
import { postcodeValidator } from "postcode-validator";

/* global ZohoHCAsap */
const chatUserImg = "/admin/images/chatUser.svg";
const redirectUrl = process.env.REACT_APP_REDIRECTION_URL_PLAN;
const socketUrl = process.env.REACT_APP_SOCKET_URL;

function Header() {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
  } = useForm();

  const history = useHistory();
  const dispatch = useDispatch();
  // 9957192058, 9772459913, 53674848494980@yopmail.com
  const [addedCountry, setAddedCountry] = useState(labelValInitialState);
  let [customError, setCustomError] = useState("");
  let [countryCode, setCountryCode] = useState("");
  const [changeState, setChangeState] = useState(labelValInitialState);

  const { selectedCareSiteName, selectedCareSiteId, adminUserData } =
    useSelector((state) => state.switchSites);
  let { careSitesData, currentPlanName, accessRoles, userDataLatest } =
    useSelector((state) => state.caresiteDataReducer);
  const moduleAccess = useMemo(() => {
    const findCurrentModule = accessRoles?.find(
      (item) => item.moduleName === "MultiSite Dashboard"
    );
    return (
      findCurrentModule?.access === "full" ||
      findCurrentModule?.access === "view"
    );
  }, [accessRoles]);

  let userData = JSON.parse(localStorage.getItem("userData"));

  const [createnewsitevisible, setcreatenewsitevisible] = useState(false);
  const [userDataState, setUserDataState] = useState(null);
  const [imgLoader, setImgLoader] = useState(false);
  const {
    userIpData,
    taxesAndCurrencyData,
    taxesAddedCountryList,
    taxesAddedStateList,
  } = useSelector((state) => state.websitePlans);

  useEffect(() => {
    dispatch(getTaxesAndCurrency());
  }, []);

  useEffect(() => {
    if (!currentCareSiteId) return;
    dispatch(getSettingList(currentCareSiteId));
    const debouncedFetch = debounce(() => {
      dispatch(setSocketCount(1));
    }, 300);
    const debouncedFetch2 = debounce(() => {
      dispatch(getSettingList(currentCareSiteId));
    }, 300);
    const socket = io(socketUrl, {
      withCredentials: true,
      transports: ["websocket", "polling"],
      auth: {
        token: localStorage.getItem("care_admin_token"),
      },
    });
    socket.on("connect", () => {
      console.log("Connected to server:", socket.id);
      socket.emit("register", currentCareSiteId);
      socket.on("taskNotification", (data) => {
        console.log("Frontend :: Task Notification Received:", data?.status);
        if (data?.status) {
          debouncedFetch();
        }
      });
      socket.on("handle_subscription_status", (data) => {
        console.log("Frontend :: Refresh Settings Socket:", data?.status);
        if (data?.status) {
          debouncedFetch2();
        }
      });
    });
    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });
    return () => {
      if (socket && currentCareSiteId) {
        socket.emit("leaveRoom", currentCareSiteId); // You'll need to implement this
      }
      socket.off("connect");
      socket.off("register");
      socket.off("taskNotification");
      socket.off("disconnect");
      debouncedFetch.cancel(); // Cancel pending calls
    };
  }, [currentCareSiteId]);

  useEffect(() => {
    setUserDataState(userData);
    if (userData) {
      dispatch(handleEmailVerifyFromLogin({ verifySuccessLogin: 0 }));
    }
    dispatch(fetchUserIpData());
  }, []);

  useEffect(() => {
    if (userIpData && taxesAddedCountryList) {
      let findCountry = countryList?.countries?.find((item) => {
        return item?.isoAlpha2?.includes(userIpData?.country);
      });
      let findCurrency = taxesAddedCountryList.find((item) =>
        item.label.includes(findCountry?.name)
      );
      if (!findCurrency) {
        findCurrency = taxesAddedCountryList?.find(
          (item) => item.label === "United Kingdom"
        );
      }
      setAddedCountry(findCurrency);
      const selectedContry = countryList.countries?.find(
        (item) => item.name === findCurrency.label
      );
      setCountryCode(selectedContry?.isoAlpha2);
    }
  }, [userIpData, taxesAddedCountryList]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://desk.zoho.eu/portal/api/web/asapApp/137666000000948003?orgId=20087490876";
    script.async = true;
    script.nonce = "{place_your_nonce_value_here}";
    script.type = "text/javascript";
    script.defer = true;
    document.body.appendChild(script);

    window.ZohoHCAsapSettings = {
      hideLauncherIcon: true,
    };

    window.addEventListener("productfruits_button_ext_widget_init", () => {
      ZohoHCAsap?.Action("open");
    });

    window.onclick = function (event) {
      if (window.productFruits?.api?.button) {
        window.productFruits.api.button.showButton();
      }
    };

    window.ZohoHCAsap?.Action("open", () => {
      window.productFruits.api.button.hideButton();
    });
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleNextone = (formValues) => {
    if (!addedCountry.label) {
      setCustomError("country");
      return;
    }
    if (location === "" && formValues.carefacility === "facalities") {
      setlocErrorMsg("location");
      return;
    }

    // Check if country code is supported by postcode-validator
    const isCountrySupported = SUPPORTED_COUNTRY_CODES.includes(countryCode);

    // If country is not supported, skip postal code validation
    if (!isCountrySupported) {
      console.warn(
        `Postal code validation not supported for country: ${countryCode}`
      );
    }

    // Only validate postal code if country is supported, otherwise proceed without validation
    if (
      isCountrySupported &&
      !postcodeValidator(formValues?.postalCode?.trim(), countryCode)
    ) {
      setCustomError("postal");
      setTimeout(() => {
        setCustomError("");
      }, 3000);
      return;
    }
    let careSiteData = {
      ...formValues,
      country: addedCountry?.label,
      countryId: addedCountry?.value,
      state: changeState?.label,
      stateId: changeState?.value,
      companyName: userDataLatest?.companyName,
      adminId: userData?._id,
    };
    if (formValues.carefacility === "facalities") {
      careSiteData.careSiteAddress = location?.Label;
      careSiteData.lattitude = location?.latitude;
      careSiteData.longitude = location?.longitude;
      careSiteData.systemUPRN = location?.uprn;
    }
    localStorage.setItem("createNewCareSiteData", JSON.stringify(careSiteData));
    history.push(`/purchagePlan`, {
      ownerId: userData._id,
      updatePlan: false,
      newCareSite: true,
    });
  };

  async function verify() {
    try {
      // Call logout API first
      const response = await httpAdmin("logout", "post");
      getOwnerId({
        loginOwnerId: "",
        loginVerifyEmail: 0,
        authProcess: "",
      });
      dispatch(handleEmailVerifyFromLogin({ verifySuccessLogin: 0 }));
      logoutAdmin();
      // localStorage.removeItem("care_admin_token");
      // localStorage.removeItem("userData");
      // localStorage.removeItem("currentCareSiteId");
      history.replace("/login");
      // window.location.reload();
    } catch (error) {
      getOwnerId({
        loginOwnerId: "",
        loginVerifyEmail: 0,
        authProcess: "",
      });
      dispatch(handleEmailVerifyFromLogin({ verifySuccessLogin: 0 }));
      logoutAdmin();
      history.replace("/login");
    }
  }

  const [show, setShow] = useState(false);
  const [popupStatus, setPopupStatus] = useState("");

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = (text) => {
    setShow(true);
    setPopupStatus(text);
  };

  const [question, setQuestion] = useState("");
  const [securityAnswer, setsecurityAnswer] = useState("");
  const { captureBeforeSwitchCareSiteId } = useSelector(
    (state) => state.switchSites
  );
  const { loginVerifyEmail } = useSelector(
    (state) => state.accountCreationApiReducer
  );

  function selectQuestion(event) {
    setQuestion(event.label);
  }

  useEffect(async () => {
    let intervalID = setInterval(async () => {
      if (loginOwnerId && loginVerifyEmail == 1) {
        await dispatch(
          authenticateOwnerSignup({ loginOwnerId: loginOwnerId, authProcess })
        );
      }
    }, 3000);
    if (loginVerifyEmail == 2) {
      swal("Success", securitysuccessfullMsg, "success").then(async (value) => {
        await dispatch(selectCareSite({ id: captureBeforeSwitchCareSiteId }));
        await dispatch(
          currentCareSiteIdHandler({
            currentCareSiteId: captureBeforeSwitchCareSiteId,
          })
        );
        currentSite(userData?._id, captureBeforeSwitchCareSiteId);
        RefreshPage();
      });
      await dispatch(
        getOwnerIdAfterLogin({
          loginOwnerId: "",
          loginVerifyEmail: 0,
          authProcess: "",
        })
      );
      return () => clearInterval(intervalID);
    }
    return () => clearInterval(intervalID);
  }, [loginVerifyEmail]);

  // -------------------------  Reset Password -------------------------  //
  async function currentSite(userId, careSiteId) {
    await dispatch(
      updateCurrentCareSite({
        userId: userId,
        careSiteId: careSiteId,
      })
    );
  }

  function checkSecurityQuestions() {
    let data = JSON.stringify({
      userId: userData?._id,
      panel: "admin",
      question: question,
      answer: securityAnswer,
    });

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/checkSecurityQuestions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === true) {
          setQuestion("");
          swal("Success", "User successfully authenticated", "success").then(
            (value) => {
              dispatch(selectCareSite({ id: captureBeforeSwitchCareSiteId }));
              dispatch(
                currentCareSiteIdHandler({
                  currentCareSiteId: captureBeforeSwitchCareSiteId,
                  status: "login",
                  loginData: response.data.data,
                })
              );

              currentSite(userData?._id, captureBeforeSwitchCareSiteId);
              response.data.data.currentCareSiteId =
                captureBeforeSwitchCareSiteId;
              localStorage.setItem("care_admin_token", response.data.token);
              localStorage.setItem(
                "userData",
                JSON.stringify(response.data.data)
              );
              handleClose();
              RefreshPage();
            }
          );
        } else {
          swal("failed", response.data.message, "error").then((value) => {
            return;
          });
        }
      })
      .catch(function (error) {
        console.log(error, "error");
      });
  }

  const handleSelectChange = async (event) => {
    const subscriptionData = careSitesData?.find(
      (item) => item._id === event.target.value
    );
    if (
      subscriptionData?.subscriptionStatus == "true" ||
      subscriptionData?.subscriptionStatus == "paused" ||
      subscriptionData?.subscriptionStatus == "blocked"
    ) {
      dispatch(captureSwitchCareSiteId({ id: event.target.value }));
      try {
        const response = await dispatch(
          switchCareSiteApi({
            userId: userData?._id,
            careSiteId: event.target.value,
          })
        );
        const res = response.payload;
        if (res.status === true) {
          if (response.payload.message == "Security question enabled") {
            handleShow("reset_securityQuestion");
            return;
          }
          if (response.payload.message.includes("No auth")) {
            swal(
              "Success",
              "You have successfully switched to other site",
              "success"
            ).then((value) => {
              dispatch(selectCareSite({ id: event.target.value }));
              dispatch(
                currentCareSiteIdHandler({
                  currentCareSiteId: event.target.value,
                })
              );
              currentSite(userData?._id, event.target.value);
              RefreshPage();
              return;
            });
          }
          if (
            response.payload.message ==
            "An authentication email has been sent to your email, Please authenticate yourself"
          ) {
            swal("Success", response.payload.message, "success").then(
              (value) => {
                dispatch(
                  getOwnerId({
                    loginOwnerId: userData?._id,
                    loginVerifyEmail: 1,
                    authProcess: "login",
                  })
                );
              }
            );
          }
        } else {
          ShowSwal(false, res.message ?? "Something went wrong! try again.");
        }
      } catch (e) {
        console.log(e, "Error messssages");
      }
    } else {
      ShowSwal(
        false,
        "This site is blocked. Kindly clear outstanding payments to activate it again."
      );
    }
  };

  function stateListHandleChange(event) {
    setChangeState(event);
  }

  async function onFileChange(e) {
    let profileImg = e.target.files;
    if (profileImg) {
      setImgLoader(true);
      let compressedImg = await compressImage(profileImg);
      editImage(compressedImg);
    }
  }

  const editImage = async (imgg) => {
    let body = new FormData();
    body.append("image", imgg);
    const res = await httpAdmin(
      `changeProfilePhoto?adminId=${userData._id}`,
      "post",
      body,
      "formdata"
    );
    if (res.status) {
      localStorage.setItem("userData", JSON.stringify(res.result));
      setUserDataState(res.result);
      setImgLoader(false);
    }
  };

  const [location, setlocation] = useState("");
  const [locErrorMsg, setlocErrorMsg] = useState("");
  function awsLocationHandler(locVal) {
    setlocation(locVal);
    if (locVal) setlocErrorMsg("");
  }

  let locationPlaceholder =
    "CareSite Location (where care services will be given)";

  function countryListHandleChange(event) {
    setCustomError("");
    setAddedCountry(event);
    const selectedContry = countryList.countries?.find(
      (item) => item.name === event.label
    );
    setCountryCode(selectedContry?.isoAlpha2);
  }

  return (
    <>
      <header className="topbar">
        <nav className="navbar top-navbar navbar-expand-md navbar-dark">
          {/* <ProductFruits workspaceCode="UHf8gK434TsyGDjw" language="en-US" {...userInfo} /> */}
          <div className="navbar-header">
            {/* <button className="nav-toggler waves-effect waves-light d-block d-md-none hemburger_menu">
              <GiHamburgerMenu />
            </button> */}
            <button
              className="nav-toggler waves-effect waves-light d-block d-md-none hemburger_menu"
              onClick={() => document.body.classList.toggle("mini-sidebar")}
            >
              <GiHamburgerMenu />
            </button>
            <a className="navbar-brand me-0" href={redirectUrl}>
              <b className="logo-icon">
                <img
                  style={{ width: "110px", transition: "none" }}
                  src={`/admin/images/logo2.svg`}
                />
              </b>
            </a>
            <NavLink
              className="topbartoggler d-block d-md-none waves-effect waves-light"
              to=""
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="ti-more"></i>
            </NavLink>
          </div>
          <div className="navbar-collapse collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto"></ul>
            <ul className="navbar-nav">
              <li className="nav-item dropdown create_list d-flex">
                {/* <h5>Hello! {`${userData?.firstName}`}</h5> */}

                <NavLink
                  className="nav-link dropdown-toggle waves-effect waves-dark"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {selectedCareSiteName}

                  {/* {JSON.stringify(data[0].careSiteName)} */}
                </NavLink>
                <div className="dropdown-menu dropdown-menu-end user-dd animated flipInY">
                  {userData?.userType === "owner" &&
                    currentPlanName === "Turbo" && (
                      <button
                        className="popupBtn popupBtn1"
                        onClick={() => {
                          setcreatenewsitevisible(true);
                          reset();
                        }}
                      >
                        Create New Site
                      </button>
                    )}
                  {currentPlanName === "Turbo" && (
                    <button
                      disabled={moduleAccess ? false : true}
                      style={{ color: moduleAccess ? "var(--main)" : "" }}
                      className="popupBtn"
                      onClick={() => {
                        history.push("/multiSites/operations");
                      }}
                    >
                      MultiSite Dashboard
                    </button>
                  )}
                  {careSitesData && careSitesData.length > 0 ? (
                    <select
                      defaultValue={selectedCareSiteId}
                      onChange={handleSelectChange}
                    >
                      {careSitesData?.map((item) => {
                        return (
                          <option
                            key={item._id}
                            value={item._id}
                            selected={
                              item?._id === selectedCareSiteId ? true : false
                            }
                          >
                            {item.careSiteName}
                          </option>
                        );
                      })}
                    </select>
                  ) : (
                    <button className="popupBtn">Not Available</button>
                  )}
                </div>
              </li>

              <li className="nav-item dropdown profile">
                <NavLink
                  className="nav-link dropdown-toggle waves-effect waves-dark"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    className={`profile-pic rounded-circle ${
                      userDataState?.image.includes("chatUser")
                        ? "forImageadmin"
                        : "table_image"
                    }`}
                    src={
                      userDataState?.image ? userDataState?.image : chatUserImg
                    }
                    alt="user"
                    width="40"
                  />
                </NavLink>
                <div className="dropdown-menu dropdown-menu-end user-dd animated flipInY">
                  <div
                    className="no-block align-items-center p-3 text-white mb-2 text-center"
                    style={{ minWidth: "270px" }}
                  >
                    <div className="">
                      {imgLoader ? (
                        <div>
                          <CircularProgress color="secondary" />
                        </div>
                      ) : (
                        <img
                          className={`profile_img rounded-circle ${
                            userDataState?.image.includes("chatUser")
                              ? "forImageadmin"
                              : ""
                          }`}
                          src={
                            userDataState?.image
                              ? userDataState?.image
                              : chatUserImg
                          }
                          alt="user"
                          width="60"
                        />
                      )}
                      <div className="editProfile_imgicon">
                        <input
                          type="file"
                          id="upLoader"
                          accept="image/*"
                          name="images"
                          onChange={onFileChange}
                        />
                        <span>
                          <AiFillPlusCircle className="edit_icon" />
                        </span>
                      </div>
                    </div>
                    <div className="ms-2">
                      <h4
                        className="mb-0"
                        style={{
                          color: "#828282",
                          fontSize: "22px",
                          fontWeight: "300",
                        }}
                      >{`${userData?.firstName} ${userData?.lastName}`}</h4>
                      <p
                        className=" mb-0"
                        style={{ color: "#828282", fontWeight: "300" }}
                      >
                        {userData?.email}
                      </p>
                    </div>
                  </div>
                  <NavLink
                    className="dropdown-item"
                    to="/profile/details"
                    style={{ color: "#828282" }}
                  >
                    Account Hub
                  </NavLink>
                  <NavLink
                    className="dropdown-item"
                    to="/event-logs"
                    style={{ color: "#828282" }}
                  >
                    Event Logs
                  </NavLink>
                  <NavLink
                    className="dropdown-item"
                    to="/settings"
                    style={{ color: "#828282" }}
                  >
                    Settings
                  </NavLink>
                  <p
                    className="dropdown-item"
                    style={{ color: "#828282" }}
                    onClick={() => verify()}
                  >
                    Logout
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <div
        className="modal modal_ak"
        id="addNewPopup"
        style={{ display: `${createnewsitevisible ? "block" : "none"}` }}
      >
        <div
          className="bg_popup"
          onClick={() => {
            setcreatenewsitevisible(false);
          }}
        ></div>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 titleN">
                  <h3>New Site Creation</h3>
                  <button
                    type="button"
                    className="btn-close close_popup_btn"
                    onClick={() => {
                      setcreatenewsitevisible(false);
                    }}
                  ></button>
                </div>
              </div>

              <div className="step1" id="step1">
                <div className="row text-center">
                  {/* <div className="col-md-6 siteCreation">
                    <h2>Step 1 <BsArrowRightShort /> </h2>
                    <h4>Care Site Details</h4>
                  </div> */}
                  <div className="col-2"></div>
                  <div className="col-md-8 contentCreate">
                    <form>
                      <h4 className="mb-4">Care Site Details</h4>
                      <div className="mb-2">
                        <input
                          type="text"
                          id="careSiteName"
                          className="form-control"
                          {...register("careSiteName", {
                            required: true,
                          })}
                          placeholder="CareSite Name"
                        />
                        {errors?.careSiteName?.type === "required" && (
                          <p className="error_style cs_error error_bottom">
                            This field is required
                          </p>
                        )}
                      </div>

                      <div className="mb-2">
                        <input
                          type="text"
                          id="address"
                          className="form-control"
                          {...register("address", {
                            required: true,
                          })}
                          placeholder="Company Address"
                        />
                        {errors?.address?.type === "required" && (
                          <p className="error_style cs_error error_bottom">
                            This field is required
                          </p>
                        )}
                      </div>

                      <div className="mb-2">
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          {...register("city", {
                            required: true,
                          })}
                          placeholder="City"
                        />
                        {errors?.city?.type === "required" && (
                          <p className="error_style cs_error error_bottom">
                            This field is required
                          </p>
                        )}
                      </div>

                      <div className="col-md-12 mb-3">
                        <Select
                          className="select_Box_border"
                          placeholder="Country"
                          options={taxesAddedCountryList}
                          value={addedCountry}
                          onChange={countryListHandleChange}
                        />
                        {customError === "country" && (
                          <span className="input_error">
                            Please Enter Country
                          </span>
                        )}
                      </div>

                      {addedCountry?.label == "United States" && (
                        <div className="col-md-12 mb-3">
                          <Select
                            placeholder="Select an State"
                            options={taxesAddedStateList}
                            onChange={stateListHandleChange}
                          />
                          {customError === "state" && (
                            <span className="input_error">
                              Please Enter State
                            </span>
                          )}
                        </div>
                      )}

                      <div>
                        <input
                          type="text"
                          id="postalCode"
                          className="form-control"
                          {...register("postalCode", {
                            required: true,
                          })}
                          placeholder="Postal Code"
                        />
                        {errors?.postalCode?.type === "required" &&
                          customError === "" && (
                            <p className="error_style cs_error error_bottom">
                              This field is required
                            </p>
                          )}
                        {customError === "postal" && (
                          <p className="error_style cs_error error_bottom">
                            Please enter correct Postal code
                          </p>
                        )}
                      </div>

                      <div className="checkbox-wrapper d-flex justify-content-start mb-2">
                        <Checkbox
                          name="isBilling"
                          {...register("isBilling", {
                            required: false,
                          })}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        <span>Use as Billing Address</span>
                      </div>

                      <select
                        className="form-control form-select"
                        {...register("carefacility", {
                          required: true,
                        })}
                      >
                        <option value="agency">Care Agency</option>
                        <option value="facalities">Care Facilities </option>
                      </select>
                      {watch("carefacility", "") === "facalities" && (
                        <div className="mb-3">
                          <AwsLocation
                            awsLocationHandler={awsLocationHandler}
                            placeholder={locationPlaceholder}
                          />
                          {locErrorMsg === "location" && (
                            <div className="error-message-container">
                              <span className="error-text">
                                This field is required
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                      {watch("carefacility", "") === "facalities" && (
                        <div className="mb-3">
                          <div className="input-wrapper">
                            <input
                              type="number"
                              id="totalBeds"
                              placeholder="No. of Beds (if site is a care facility)"
                              className="form-control"
                              {...register("totalBeds", {
                                required: true,
                              })}
                            />
                            {errors?.totalBeds?.type === "required" && (
                              <div className="error-message-container">
                                <span className="error-text">
                                  This field is required
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-md-12 submitBtn">
                <button className="btn" onClick={handleSubmit(handleNextone)}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupStatus === "reset_securityQuestion" && (
        <Modal className="viewModal" show={show}>
          <Modal.Header>
            <Modal.Title>
              <span>Enter Security Question</span>
              {/* <button
                className="popupCloseIcon"
                title="Close"
                onClick={handleClose}
              >
                <MdClose />
              </button> */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <h4>Security Questions</h4>
              <Select
                options={securityQuestions}
                onChange={selectQuestion}
                required={true}
              />
              {question !== "" && (
                <input
                  style={{ marginTop: "20px" }}
                  type="text"
                  id="securityAnswer"
                  className={"form-control mt-2 "}
                  value={securityAnswer}
                  onChange={(e) => setsecurityAnswer(e.target.value)}
                  placeholder="Security Answer"
                />
              )}{" "}
              <button
                type="button"
                onClick={checkSecurityQuestions}
                className="form-control btn"
              >
                Authenticate{" "}
              </button>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
export default Header;
